import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'next-i18next';

const useStyles = makeStyles(theme => ({
  stepContainer: {
    marginTop: 54,
    marginBottom: 70,
    [theme.breakpoints.up('md')]: {
      marginTop: 114,
      marginBottom: 70,
    },
  },
  heading: {
    marginBottom: 50,
  },
  mobileContent: {
    textAlign: 'center',
    display: 'block',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  desktopContent: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'block',
    },
  },
  stepLabel: {
    color: '#fff',
    padding: '3px 6px',
    fontSize: 10,
    borderRadius: 20,
    width: 50,
    margin: '0 auto 13px auto',
    backgroundColor: '#58657C',
    border: '2px solid #000',
    whiteSpace: 'nowrap',
  },
  stepWrapper: { display: 'flex', flexDirection: 'column', marginBottom: 33 },
  icon: {
    marginBottom: 18,
  },
  label: {
    fontSize: 16,
    margin: '0 auto 29px auto',
  },
}));

const Index = ({ locale }) => {
  const classes = useStyles();
  const { t } = useTranslation('common');

  return (
    <div className={['container', classes.stepContainer].join(' ')}>
      <div className={classes.mobileContent}>
        {locale === 'cn' ? (
          <img src="/static/images/affiliate-step-heading.svg" className={classes.heading} />
        ) : (
          <img src="/static/images/affiliate-step-heading-en.svg" className={classes.heading} />
        )}
        <div className={classes.stepWrapper}>
          <div className={classes.stepLabel}>{t('step-1')}</div>
          <div>
            <img src="/static/images/affiliate-step-1.svg" height="88" className={classes.icon} />
          </div>
          <p
            className={classes.label}
            dangerouslySetInnerHTML={{ __html: t('affiliate-step-1-label') }}
          ></p>
          <div>
            <img src="/static/images/affiliate-step-divider.svg" height="52" />
          </div>
        </div>
        <div className={classes.stepWrapper}>
          <div className={classes.stepLabel}>{t('step-2')}</div>
          <div>
            <img src="/static/images/affiliate-step-2.svg" height="88" className={classes.icon} />
          </div>
          <p
            className={classes.label}
            dangerouslySetInnerHTML={{ __html: t('affiliate-step-2-label') }}
          ></p>
          <div>
            <img src="/static/images/affiliate-step-divider.svg" height="52" />
          </div>
        </div>
        <div className={classes.stepWrapper}>
          <div className={classes.stepLabel}>{t('step-3')}</div>
          <div>
            <img src="/static/images/affiliate-step-3.svg" height="92" className={classes.icon} />
          </div>
          <p
            className={classes.label}
            dangerouslySetInnerHTML={{ __html: t('affiliate-step-3-label') }}
          ></p>
          <div>
            <img src="/static/images/affiliate-step-divider.svg" height="52" />
          </div>
        </div>
        <div className={classes.stepWrapper}>
          <div className={classes.stepLabel}>{t('step-4')}</div>
          <div>
            <img src="/static/images/affiliate-step-4.svg" height="102" className={classes.icon} />
          </div>
          <p
            className={classes.label}
            dangerouslySetInnerHTML={{ __html: t('affiliate-step-4-label') }}
          ></p>
        </div>
      </div>
      <div className={classes.desktopContent}>
        {locale === 'cn' ? (
          <img src="/static/images/affiliate-steps.png" width="100%" />
        ) : (
          <img src="/static/images/affiliate-steps-en.svg" width="100%" />
        )}
      </div>
    </div>
  );
};

export default Index;
